import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { labels } from "../../../../../../../localization/labels";
import SubmitButton from "../../../../../../core/SubmitButton";
import ClassificationGeneralData from "./generalData/ClassificationGeneralData";
import ClassificationModelSelection from "./modelSelection";
import { Affix } from "antd";
import ComponentHeader from "../../../../../../core/ComponentHeader/ComponentHeader";

const ClassificationDetail = props => {
  return (
    <div className="container">
      <ComponentHeader
        title={labels.classification}
        id={props.entity.id}
        showBackButton
      />
      <div className="bordered_bottom_rounded">
        <br></br>

        {!props.isNew && props.entity.modelEnabled ? (
          <Tabs id="km_class_admin_id">
            <Tab eventKey="generalClassification" title={labels.generalData}>
              <ClassificationGeneralData
                entity={props.entity}
                onChange={props.onChange}
                maxLength={props.maxLength}
                isNew={props.isNew}
                validationRules={props.validationRules}
                statuses={props.statuses}
                types={props.types}
                possibleParents={props.possibleParents}
              />
            </Tab>
            <Tab
              eventKey="classificationModel"
              title={labels.classificationModel}
            >
              <ClassificationModelSelection
                onSelectModel={props.onSelectModel}
                selectedModels={props.selectedModels}
                removeModel={props.removeModel}
                messageHandler={props.messageHandler}
                breadcrumbsHandler={props.breadcrumbsHandler}
              />
            </Tab>
          </Tabs>
        ) : (
          <ClassificationGeneralData
            entity={props.entity}
            onChange={props.onChange}
            maxLength={props.maxLength}
            isNew={props.isNew}
            validationRules={props.validationRules}
            statuses={props.statuses}
            types={props.types}
            possibleParents={props.possibleParents}
          />
        )}
      </div>
      <Affix offsetBottom={true}>
        <div className="bottom_bar">
          {!props.isNew ? (
            <SubmitButton
              type="delete"
              onClick={props.handleOnDelete}
              showLoader
            />
          ) : null}
          <SubmitButton
            type="save"
            onClick={props.onSave}
            disabled={props.disabled}
          />
        </div>
      </Affix>
    </div>
  );
};

export default ClassificationDetail;
